module.exports = function getResource(label, vars = []) {
    let resources = {
        openUntil: 'Open until ',
        closed: 'Closed',
        storeHoursUnavailable: 'Store hours not available'
    };
    return resources[label];
};
